



























import {Component, Prop, Vue} from 'vue-property-decorator';
import WebType from './Type/WebType';
//utils
import Utils from '../utils/utils';
@Component
export default class Footer extends Utils {
  private webList: WebType[] = [
    {name: '易互动', url: 'http://www.ei-marketing.cn/'},
    {name: '智能思为', url: 'http://www.ei-marketing.net/'}
  ];
  created() {
    console.log('footer');
  }
  private toWeb(item: WebType) {
    window.open(item.url);
  }
}
